import {selectHasUnrestrictedLocaleAccess} from '@packages/domains/authorization/abilities';
import {abilityFeature} from '../abilityFeature';

export const hasUnrestrictedLocaleAccess = abilityFeature({
  key: 'hasUnrestrictedLocaleAccess',
  isValid(state, expected) {
    return selectHasUnrestrictedLocaleAccess(state) === expected;
  },
});
